/* global MutationObserver */

import ApplicationController from '../application_controller'

// On the edit page, the profile dropdown is turned into a hover popover by
// Helpers.dropdown2popover (see app/javascript/lib/helpers.js), which clones
// the dropdown-menu links into a detached popover element. Clicks on those
// clones need to be re-dispatched to the matching #basic_data/#personal_data
// tab link in ul#candidate_nav, since the clones themselves aren't wired to
// Bootstrap's tab handling.
class ProfileMenuController extends ApplicationController {
  static values = { editTab: Boolean }

  connect () {
    if (!this.editTabValue) return

    this.observer = new MutationObserver(() => {
      const describedBy = this.element.getAttribute('aria-describedby')
      if (!describedBy) return

      this.observer.disconnect()
      document.getElementById(describedBy)?.addEventListener('click', (event) => {
        const anchor = event.target.dataset.link
        if (anchor) document.querySelector(`ul#candidate_nav a[href="${anchor}"]`)?.click()
      })
    })

    this.observer.observe(this.element, { attributes: true })
  }

  disconnect () {
    this.observer?.disconnect()
  }
}

export default ProfileMenuController
